export const marketplaceAddress = "0xefe09c7ae074a6ffbccec96d75256290edc8fd19";
export const characterAddress = "0x9ee70fef1886890677f4c03e86508185e888b994";
export const chainID = 56;
export const network = "mainnet";

export const delay = ms => new Promise(res => setTimeout(res, ms));